import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { SIM_TYPES } from '@interfaces/sim.interace';
import { TagService } from '@shared/tag/tag.service';
import { ACTION_CLICK } from '@shared/tag/tag.interface';


@Component({
    selector: 'checkout-sim-incompatibility-alert',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sim-incompatibility-alert.component.html',
})
export class SimIncompatibilityAlertComponent {
    @Input() simType: string;
    @Output() compatibilityLinkClick = new EventEmitter<void>();

    protected tagService: TagService = inject(TagService);

    ngOnInit(): void {
        this.tagService.send({
            nomClic:
                this.simType === SIM_TYPES.QRESIM
                    ? 'Affichage_modale_incompatibilite_eSIM'
                    : 'Affichage_modale_incompatibilite_carte_SIM',
            categorieClic:
                this.simType === SIM_TYPES.QRESIM ? 'Modale_incompatibilite_eSIM' : 'Modale_incompatibilite_carte_SIM',
            actionClic: ACTION_CLICK.PRINTING,
        });
    }

    public get title(): string {
        return `${this.simType === SIM_TYPES.QRESIM ? 'L\'eSIM' : 'La carte SIM physique'} n'est pas compatible avec cet appareil`;
    }

    public get description(): string {
        const incompatibleType = this.simType === SIM_TYPES.QRESIM ? 'eSIM' : 'carte SIM physique';
        const recommendedType = this.simType === SIM_TYPES.QRESIM ? 'carte SIM physique' : 'eSIM';

        return `<p class="text is-level-2">L'appareil que vous avez ajouté au panier ne permet pas d'utiliser une ${incompatibleType}.</p>
                <p class="text is-level-2 has-text-weight-semibold">Nous vous conseillons de choisir une ${recommendedType}.</p>
                <p class="text is-level-2">Si vous choisissez une ${incompatibleType} maintenant, vous devrez l'utiliser avec un autre appareil.</p>`;
    }

    public get showCompatibilityLink(): boolean {
        return this.simType === SIM_TYPES.QRESIM;
    }

    public onCompatibilityLinkClick(): void {
        this.compatibilityLinkClick.emit();
    }
}
